export const AVAIL_META = {
  disponible: { label: "Disponible", dot: "bg-emerald-500", text: "text-emerald-700", bg: "bg-emerald-50" },
  occupe: { label: "Occupé", dot: "bg-rose-500", text: "text-rose-700", bg: "bg-rose-50" },
  absent: { label: "Absent", dot: "bg-amber-500", text: "text-amber-700", bg: "bg-amber-50" },
  hors_ligne: { label: "Hors ligne", dot: "bg-slate-400", text: "text-slate-500", bg: "bg-slate-100" },
  desactive: { label: "Désactivé", dot: "bg-slate-300", text: "text-slate-400", bg: "bg-slate-50" },
};

export const CALLER_META = {
  NOUVEAU: { label: "Nouveau numéro", cls: "bg-violet-100 text-violet-700", dot: "bg-violet-500" },
  PROSPECT: { label: "Prospect existant", cls: "bg-sky-100 text-sky-700", dot: "bg-sky-500" },
  CLIENT: { label: "Client existant", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
};

export const RESULT_META = {
  EN_COURS: { label: "En cours", cls: "bg-blue-100 text-blue-700", dot: "bg-blue-500" },
  REPONDU: { label: "Répondu", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
  MESSAGERIE: { label: "Messagerie", cls: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  REJETE: { label: "Rejeté (bloqué)", cls: "bg-rose-100 text-rose-700", dot: "bg-rose-500" },
  RENVOI_SPECIAL: { label: "Renvoi spécial", cls: "bg-fuchsia-100 text-fuchsia-700", dot: "bg-fuchsia-500" },
  MANQUE: { label: "Manqué", cls: "bg-orange-100 text-orange-700", dot: "bg-orange-500" },
  // Raccroché pendant la sonnerie : l'appelant n'a atteint ni un commercial ni
  // la messagerie. À distinguer d'un manqué, qui a sonné jusqu'au bout.
  ABANDONNE: { label: "Raccroché avant réponse", cls: "bg-yellow-100 text-yellow-800", dot: "bg-yellow-500" },
  TERMINE: { label: "Terminé", cls: "bg-slate-100 text-slate-600", dot: "bg-slate-400" },
};

export const DIRECTION_META = {
  ENTRANT: { label: "Entrant", cls: "bg-sky-100 text-sky-700", dot: "bg-sky-500" },
  SORTANT: { label: "Sortant", cls: "bg-indigo-100 text-indigo-700", dot: "bg-indigo-500" },
};

export const FLAG_META = {
  SIGNALE: { label: "Signalé (à valider)", cls: "bg-amber-100 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  SURVEILLE: { label: "Surveillé", cls: "bg-sky-100 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  INDESIRABLE: { label: "Indésirable", cls: "bg-orange-100 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  BLOQUE: { label: "Bloqué", cls: "bg-rose-100 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

// Gabarit visuel commun aux écrans Téléphonie (cf. handoff « Système commun »).
// Toute couleur de statut vient des *_META ci-dessus : pas de palette locale.
export const CARD = "bg-white rounded-2xl border border-slate-200";
export const THEAD = "text-xs font-mono uppercase tracking-wider text-slate-400 bg-slate-50/70 border-b border-slate-100";
export const TR = "border-b border-slate-50 hover:bg-slate-50/70";
export const PILL = "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap";
export const DOT = "h-1.5 w-1.5 rounded-full shrink-0";
export const AVATAR_BG = ["bg-indigo-500", "bg-sky-600", "bg-emerald-600", "bg-amber-600", "bg-fuchsia-600", "bg-teal-600"];

export const inputCls =
  "w-full px-3 py-2.5 rounded-xl border border-slate-300 bg-white text-sm outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/15";
export const btnPrimary =
  "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 disabled:opacity-50";
export const btnGhost =
  "inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-xl border border-slate-200 bg-white text-sm text-slate-600 hover:border-slate-300 hover:bg-slate-50 disabled:opacity-50";
export const btnDanger =
  "inline-flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg border border-rose-200 bg-white text-rose-600 text-xs font-medium hover:bg-rose-50";
export const btnSuccess =
  "inline-flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs font-medium hover:bg-emerald-700";
export const iconBtn =
  "inline-flex items-center justify-center p-2 rounded-lg border border-slate-200 bg-white text-slate-500 hover:border-slate-300 hover:text-slate-700";
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR") : "—");
